<script lang="ts">
	import { t } from '$lib/translations';
	export let type: 'events' | 'slots' = 'events';
</script>

<div
	class="col-span-full h-48 text-center flex justify-center items-center text-quaternary font-bold"
>
	Zu den gewählten Kriterien sind leider keine {$t(`common.${type}`)} verfügbar!
</div>
